import { useState, useEffect, useCallback } from "react";
import { useUserModuleState } from "..";
import useEndGame from "./use-end-game";
import { GAME_DURATION } from "../../../config";

export function useTimeToEnd() {
    const [time, setTime] = useState(0);
    const { gameStartTime: gameStart } = useUserModuleState()
    const endGame = useEndGame();

    const updateTime = useCallback(() => {
        if (gameStart) {
            const time = Math.floor((GAME_DURATION - (Date.now() - gameStart)) / 1000)

            if (time < 0) {
                endGame();
            }

            setTime(time);
        }
    }, [setTime, gameStart, endGame])

    useEffect(() => {
        const id = setInterval(updateTime, 500);

        return () => { clearInterval(id) };
    }, [updateTime])

    return time;
}
